// extracted by mini-css-extract-plugin
export var fadeIn = "_28-0";